export default __webpack_public_path__ + "static/media/modulos.b32487f5.png";